import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-visibility-off",
  templateUrl: "./med-icon-visibility-off.component.html",
})
export class MedIconVisibilityOffComponent extends SvgMixinComponent {}
